import { render } from "./InputSubheader.vue?vue&type=template&id=2b8ca57e"
import script from "./InputSubheader.vue?vue&type=script&lang=js"
export * from "./InputSubheader.vue?vue&type=script&lang=js"
script.render = render

export default script